import React from 'react'

const Services = () => {
    return (
        <div>
            <main id="content" className="site-main" style={{ overflowX: "hidden" }}>
                {/* Inner Banner html start*/}
                <section className="inner-banner-wrap bg-light-grey">
                    <div
                        className="inner-baner-container"
                        style={{ backgroundImage: "url(assets/images/banner-pattern1.png)" }}
                    >
                        <div className="container">
                            <div className="inner-banner-content">
                                <h1 className="inner-title">Services</h1>
                            </div>
                        </div>
                    </div>
                </section>
                {/* Inner Banner html end*/}
                {/* service html start */}
                <div className="service-page-section">
                    <div className="service-page-inner bg-light-grey">
                        <div className="container">
                            <div className="row">
                                <div className="col-sm-6 col-lg-4">
                                    <div className="service-icon-box">
                                        <div className="service-icon">
                                            <i aria-hidden="true" className="icon icon-Consultancy" />
                                        </div>
                                        <div className="service-icon-content">
                                            <h4>Web Development</h4>
                                            <p>
                                                Our full-stack web development teams are committed to bringing out the most efficient and valuable web applications that are fast, responsive, search-engine-optimized and user-friendly.


                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6 col-lg-4">
                                    <div className="service-icon-box">
                                        <div className="service-icon">
                                            <i aria-hidden="true" className="icon icon-Mechanic" />
                                        </div>
                                        <div className="service-icon-content">
                                            <h4>Digital Marketing</h4>
                                            <p>
                                                In the present digital age, digital advertising plays a crucial role. As people depend more on the web to make a purchase or avail of a service, it is essential to have your business an enhanced presence


                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6 col-lg-4">
                                    <div className="service-icon-box">
                                        <div className="service-icon">
                                            <i aria-hidden="true" className="icon icon-rocket-ship" />
                                        </div>
                                        <div className="service-icon-content">
                                            <h4>UI & UX </h4>
                                            <p>
                                                Make a solid bond between your clients and your brand by giving them a client-driven structure and consistent client experience. UI&UX design can ideally cater to all user requisites with exceptional designs.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6 col-lg-4">
                                    <div className="service-icon-box">
                                        <div className="service-icon">
                                            <i aria-hidden="true" className="icon icon-graph-2" />
                                        </div>
                                        <div className="service-icon-content">
                                            <h4>Cloud Services</h4>
                                            <p>
                                                Codenix Infotech's expertise in the area of cloud computing covers several dimensions. With the know-how of the two standard cloud services, we offer cloud enablement of our other services in various configurations


                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6 col-lg-4">
                                    <div className="service-icon-box">
                                        <div className="service-icon">
                                            <i aria-hidden="true" className="icon icon-idea" />
                                        </div>
                                        <div className="service-icon-content">
                                            <h4>AI & ML</h4>
                                            <p>
                                                Artificial Intelligence (AI) is rapidly transforming how businesses operate and can potentially revolutionize the world as we know it. At Codenix Infotech, we understand the potential of this cutting-edge technology


                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6 col-lg-4">
                                    <div className="service-icon-box">
                                        <div className="service-icon">
                                            <i aria-hidden="true" className="icon icon-Target" />
                                        </div>
                                        <div className="service-icon-content">
                                            <h4>App development </h4>
                                            <p>
                                                Smartphones have revolutionized the present age. Hence, Codenix Infotech mobile applications are evolved to be a valuable asset that drives the digital transformation of business across diverse industries
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="callback-inner d-none">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-7 d-flex flex-wrap align-items-center">
                                    <div className="callback-content-wrap">
                                        <div className="title-divider" />
                                        <h2 className="section-title">
                                            Subscribe Newsletter For Latest{" "}
                                            <span className="primary-color">Update</span>
                                        </h2>
                                        <p>
                                            Sodales imperdiet nunc quia omnis maecenas cubilia, purus,
                                            dolor! Est volutpat aliquid, elit excepturi.Laoreet! Sodales
                                            imperdiet nunc quia omnis maecenas cubilia, purus, dolor!.
                                        </p>
                                        <form method="get" className="subscribe-form">
                                            <input
                                                type="email"
                                                name="email"
                                                placeholder="Enter your email*"
                                            />
                                            <button type="submit" className="button-round">
                                                Subscribe
                                            </button>
                                        </form>
                                    </div>
                                </div>
                                <div className="col-md-5 d-flex flex-wrap align-items-end pricing-callback-img">
                                    <figure className="callback-img">
                                        <img src="assets/images/img15.png" alt="" />
                                    </figure>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* service html end */}
            </main>

        </div>
    )
}

export default Services
